import { Component, DestroyRef, inject, Inject, OnInit, ViewChild } from '@angular/core';
import { ArivoPaymentMethod, DashboardResolve, Money } from '@shared/models';
import { ActivatedRoute } from '@angular/router';
import { TypedRoute } from '@shared/utils';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ArivoPaymentContainerComponent, ArivoPaymentService } from '@shared/components';
import { AmplitudeEventService, CoreDataService, FeatureFlagService } from '@core/services';

@Component({
  selector: 'app-dashboard-account-balance',
  templateUrl: './dashboard-account-balance.component.html',
  styleUrl: './dashboard-account-balance.component.scss',
})
export class DashboardAccountBalanceComponent implements OnInit {
  @ViewChild('paymentContainer') paymentContainer!: ArivoPaymentContainerComponent;
  private destroyRef = inject(DestroyRef);
  creditCardIconClass: string | null = null;
  openCosts: Money[] = [];
  paymentMethod: ArivoPaymentMethod | null = null;
  adyenIframeEnabled: boolean = false;
  showPayPerUse: boolean = false;

  constructor(
    @Inject(ActivatedRoute) private route: TypedRoute<DashboardResolve>,
    private paymentService: ArivoPaymentService,
    private coreDataService: CoreDataService,
    private featureFlagService: FeatureFlagService,
    private amplitudeEventService: AmplitudeEventService,
  ) {}

  get hasExternalPaymentMethod(): boolean {
    return this.coreDataService.coreData.value.customer_settings?.has_external_payment_method;
  }

  ngOnInit(): void {
    this.adyenIframeEnabled = this.featureFlagService.getFeatureFlag('enable_iframe_adyen');
    this.showPayPerUse = this.featureFlagService.getFeatureFlag('enable_ppu') === true;

    this.route.data.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
      this.openCosts = data.dashboardApiResponse.open_costs;
      this.paymentMethod = data.dashboardApiResponse.payment_method;
      this.coreDataService.setPaymentMethodAvailability(!!this.paymentMethod);
      if (this.paymentMethod?.brand) {
        this.creditCardIconClass = this.paymentService.getCreditCardIcon(this.paymentMethod.brand);
      }
      if (this.paymentMethod) {
        this.amplitudeEventService.updateUserProperties({
          properties: {
            paymentMethod: this.paymentMethod.type,
          },
        });
      }
    });
    this.paymentService.activePaymentMethod.subscribe((paymentMethod) => {
      if (paymentMethod) {
        this.paymentMethod = paymentMethod;
        if (this.paymentMethod?.brand) {
          this.creditCardIconClass = this.paymentService.getCreditCardIcon(this.paymentMethod.brand);
        }
        this.amplitudeEventService.updateUserProperties({
          properties: {
            paymentMethod: this.paymentMethod.type,
          },
        });
      }
    });
  }
}
